const ExpandableTableSortOption = Object.freeze({
  ASCEND: 'ASCEND',
  DESCEND: 'DESCEND',
  NONE: 'NONE'
})
export default ExpandableTableSortOption
// RESERVE BELOW
